export const editorialTocs: Record<string, { id: string; label: string }[]> = {
  "sim-only-mnp-campaigns": [
    { id: "answer", label: "先に結論" },
    { id: "compare", label: "5社のSIMのみ特典" },
    { id: "choice", label: "容量と条件で選ぶ" },
    { id: "device", label: "iPhone同時購入との違い" },
    { id: "apply", label: "申込先を確認する" },
    { id: "sources", label: "各社の公式条件" },
  ],
  "uqmobile-guide": [
    { id: "answer", label: "au回線の安心感を残して安くする" },
    { id: "price", label: "30GB・35GBの料金プラン" },
    { id: "plan-choice", label: "2つのプランの選び方" },
    { id: "store-family", label: "家族割と店舗サポート" },
    { id: "devices", label: "端末も一緒に購入できる" },
    { id: "return-program", label: "実質価格と2年返却" },
    { id: "iphone18", label: "iPhone 18 Proを使う方法" },
    { id: "campaigns", label: "2万円相当のSIM特典" },
    { id: "before-change", label: "申込み前の確認事項" },
    { id: "apply", label: "キャンペーン・端末を見る" },
  ],
  "ymobile-guide": [
    { id: "answer", label: "安さと店舗の安心感を両立" },
    { id: "price", label: "5GB・30GB・35GBの料金" },
    { id: "family-store", label: "家族割と店舗サポート" },
    { id: "devices", label: "端末も一緒に購入できる" },
    { id: "iphone18", label: "iPhone 18 Proを使う方法" },
    { id: "campaigns", label: "現在のキャンペーン" },
    { id: "before-change", label: "申込み前の確認事項" },
    { id: "apply", label: "キャンペーン・端末を見る" },
  ],
  "are-you-overpaying": [
    { id: "forty-years", label: "40年前と現在の料金" },
    { id: "current-average", label: "現在の平均月額" },
    { id: "price-turn", label: "2026年の料金変化" },
    { id: "five-leaks", label: "払い続けやすい5つ" },
    { id: "not-only-cheap", label: "安ければ正解ではない" },
    { id: "three-actions", label: "今日できる3つ" },
    { id: "sources", label: "出典・確認資料" },
    { id: "next-actions", label: "次の行動" },
  ],
  "which-plan-is-cheapest": [
    { id: "quick-pick", label: "使い方別の入口" },
    { id: "four-layers", label: "携帯料金の4つの種類" },
    { id: "light-user", label: "月3GB前後の比較" },
    { id: "medium-user", label: "月15〜20GBの比較" },
    { id: "heavy-user", label: "月30〜40GBの比較" },
    { id: "unlimited-user", label: "無制限の比較" },
    { id: "cheap-caveats", label: "安さの条件" },
    { id: "four-steps", label: "選ぶ順番" },
    { id: "sources", label: "公式情報" },
    { id: "next-actions", label: "次の行動" },
  ],
  "return-program": [
    { id: "answer", label: "先に結論：返却時期と費用" },
    { id: "timing", label: "4社の返却時期" },
    { id: "costs", label: "返却時の費用と故障時の追加費用" },
    { id: "calculation", label: "実質価格の見方" },
    { id: "checklist", label: "申込み前・返却前の4項目" },
    { id: "official", label: "各社の公式条件" },
  ],
  "rakuten-iphone-17e": [
    { id: "answer", label: "最初に知っておきたいこと" },
    { id: "monthly", label: "毎月の支払い" },
    { id: "device-total", label: "返す場合・返さない場合の総額" },
    { id: "benefits", label: "回線を楽天にする理由" },
    { id: "cautions", label: "申込み前の注意点" },
    { id: "campaign-conditions", label: "月1円の条件" },
    { id: "apply", label: "申込み手順" },
  ],
  "rakuten-iphone-18-pro": [
    { id: "answer", label: "最初に知っておきたいこと" },
    { id: "monthly", label: "毎月の支払い" },
    { id: "device-total", label: "返す場合・返さない場合の総額" },
    { id: "benefits", label: "回線を楽天にする理由" },
    { id: "cautions", label: "申込み前の注意点" },
    { id: "campaign-conditions", label: "ポイントの条件" },
    { id: "apply", label: "申込み手順" },
  ],
  "iphone-18-pro-mnp": [
    { id: "answer", label: "先に結論：返却するかで選ぶ" },
    { id: "return-price", label: "約2年で返却する人" },
    { id: "price", label: "返却せずに使い続ける人" },
    { id: "choice", label: "どちらにするか迷ったら" },
    { id: "compare", label: "通信費も合わせて確認" },
    { id: "official", label: "公式ページで確認" },
  ],
  "ahamo-guide": [
    { id: "answer", label: "どんな人に向いている？" },
    { id: "quick-decision", label: "2つの申込み方法" },
    { id: "savings", label: "年間の節約額" },
    { id: "benefits", label: "8つのメリット" },
    { id: "price", label: "2,970円に含まれるもの" },
    { id: "unlimited-call", label: "月4,070円で完全かけ放題" },
    { id: "device", label: "端末も一緒に購入できる" },
    { id: "campaign", label: "乗り換えキャンペーン" },
    { id: "concrete-cases", label: "3人の具体例" },
    { id: "cautions", label: "申込み後に困りやすいこと" },
    { id: "before-change", label: "申込み前の最終チェック" },
    { id: "apply", label: "申込み方法を選ぶ" },
    { id: "sources", label: "公式情報" },
    { id: "next-actions", label: "次の行動" },
  ],
  "iijmio-guide": [
    { id: "answer", label: "どんな人に向いている？" },
    { id: "quick-decision", label: "回線だけ・端末セットを選ぶ" },
    { id: "price", label: "容量別の通常料金" },
    { id: "network", label: "ドコモ網・au網を選べる" },
    { id: "campaign", label: "現在のキャンペーン" },
    { id: "device", label: "iPhoneも分割で買える" },
    { id: "call", label: "通話料金・かけ放題" },
    { id: "benefits", label: "8つのメリット" },
    { id: "cautions", label: "申込み後に困りやすいこと" },
    { id: "before-change", label: "申込み前の確認順" },
    { id: "apply", label: "端末価格・在庫を確認" },
    { id: "sources", label: "公式情報" },
  ],
  "iijmio-iphone-no-return": [
    { id: "problem", label: "2年返却を選ばなかった理由" },
    { id: "choice", label: "選んだ回線とiPhone" },
    { id: "monthly", label: "通信費と端末代の月額" },
    { id: "why-iij", label: "IIJmioが有力だった理由" },
    { id: "family-limit", label: "父の分も買おうとして分かった制限" },
    { id: "used-check", label: "中古iPhoneの注意点" },
    { id: "not-for", label: "この方法を勧めない人" },
    { id: "steps", label: "購入前の手順" },
    { id: "apply", label: "現在の在庫を見る" },
    { id: "sources", label: "計算・条件の確認元" },
  ],
  "rakuten-guide": [
    { id: "answer", label: "どんな人に向いている？" },
    { id: "price", label: "月1,078〜3,278円" },
    { id: "link-call", label: "Rakuten Linkで通話無料" },
    { id: "benefits", label: "8つのメリット" },
    { id: "campaign", label: "契約でポイントがもらえる" },
    { id: "device", label: "iPhone 18 Proも買える" },
    { id: "sources", label: "公式情報" },
    { id: "apply", label: "端末・キャンペーンを見る" },
  ],
  "before-switching": [
    { id: "answer", label: "最初に今の契約を整理" },
    { id: "five-checks", label: "乗り換え前の5項目" },
    { id: "timing", label: "前日・当日・翌日の流れ" },
    { id: "mistakes", label: "よくある失敗" },
    { id: "next-actions", label: "次の行動" },
  ],
  "data-usage": [
    { id: "answer", label: "必要量の決め方" },
    { id: "check-usage", label: "3か月の使用量を確認" },
    { id: "guide", label: "容量帯ごとの目安" },
    { id: "reduce", label: "勝手に増える通信を確認" },
    { id: "next-actions", label: "次の行動" },
  ],
  "iphone-buy": [
    { id: "answer", label: "返却するかで買い方を分ける" },
    { id: "where", label: "購入先ごとの違い" },
    { id: "compare", label: "購入先で確認する4つの費用" },
    { id: "choice", label: "使い方別の選び方" },
    { id: "next-actions", label: "次の行動" },
  ],
  "iphone-repair-or-replace": [
    { id: "answer", label: "修理か買い替えかの結論" },
    { id: "three-axes", label: "判断する3つの軸" },
    { id: "battery", label: "バッテリーを確認" },
    { id: "decision", label: "同じ紙に書いて比較" },
    { id: "next-actions", label: "次の行動" },
  ],
  "used-iphone-checklist": [
    { id: "answer", label: "最初にロック状態を確認" },
    { id: "seven-checks", label: "購入前の7項目" },
    { id: "seller", label: "個人売買と中古店の違い" },
    { id: "source", label: "Apple公式の確認手順" },
    { id: "next-actions", label: "次の行動" },
  ],
};
